"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var insta_feed_vue_1 = require("../components/instagram/insta-feed.vue");
new vue_1.default({
    el: '.insta-widget',
    components: {
        InstaFeed: insta_feed_vue_1.default
    }
});
